import RouteDetailMap from '../components/RouteDetailMap.vue';
import RouteDetailMapV2 from '../components/RouteDetailMapV2.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import SpotService from '../services/SpotService';
import showAlert from '@waypoint/vue-alert';
import showConfirmation from '@waypoint/vue-confirmation';
import axios from 'axios';
import Container from 'typedi';

import secureModeEscl from '../locales/es-CL/secureMode.json';
import secureModeEsmx from '../locales/es-MX/secureMode.json';
import secureModeEsco from '../locales/es-CO/secureMode.json';
import secureModeEnus from '../locales/en-US/secureMode.json';

export default {
  name: 'SecureMode',
  components: { GoogleMapsApiLoader, RouteDetailMap, RouteDetailMapV2 },
  i18n: {
    messages: {
      'es-CL': {
        secureMode: secureModeEscl,
      },
      'es-MX': {
        secureMode: secureModeEsmx,
      },
      'es-CO': {
        secureMode: secureModeEsco,
      },
      'en-US': {
        secureMode: secureModeEnus,
      },
    },
  },
  data() {
    return {
      spotService: null,
      gapi: null,
      dataAccess: null,
      showMap: false,
      showTrips: true,
      isFilterShown: false,
      isFilterClicked: false,
      isFilterApplied: false,
      actualMode: null,
      isTripsSecureBussy: false,
      currentPageTrips: 1,
      perPageTrips: 10,
      pageOptions: [10, 15, 20, 50, 100],
      filters: {
        tripName: null,
        origin: null,
        destination: null,
      },
      tripName: null,
      selectedOrigin: null,
      selectedDestination: null,
      selectedWidth: 60,
      selectedIdSecureRoute: null,
      selectedSecureRoute: null,
      spotsOrigin: null,
      spotsDestination: null,
      dataSecureRoutes: [],
      secureRoutes: [],
      widthRoute: [60, 70, 80, 90, 100, 250, 500, 1000],
      errorLog: null,
    };
  },
  async created() {
    this.spotService = Container.get(SpotService);
    await GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.isTripsSecureBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      this.dataSecureRoutes = await this.getSecureRoutes();
      this.tripSecures(this.dataSecureRoutes);
      this.spotsOrigin = this.spotsDestination = await this.spotService.getSpots();
      this.isTripsSecureBussy = false;
    },
    async getSecureRoutes() {
      const urlAlert = `${this.$store.getters.urlAPI}/secureZone`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const dataSecureRoutes = await axios.get(urlAlert, config);
        return dataSecureRoutes.data.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async postSecureRoutes(body) {
      const urlAlert = `${this.$store.getters.urlAPI}/secureZone`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const postSecureRoutes = await axios.post(urlAlert, body, config);
        return postSecureRoutes.data;
      } catch (e) {
        this.errorLog = e.response.data;
        return false;
      }
    },
    async patchSecureRoutes(body) {
      const urlAlert = `${this.$store.getters.urlAPI}/secureZone/${this.selectedSecureRoute.id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const patchSecureRoutes = await axios.patch(urlAlert, body, config);
        return patchSecureRoutes.data;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async deleteSecureRoute() {
      const urlAlert = `${this.$store.getters.urlAPI}/secureZone/${this.selectedSecureRoute.id}`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const deleteSecureRoutes = await axios.delete(urlAlert, config);
        //Si la eliminacion se realizo correctamente mostrara un mensaje de exito y se limpiara el mapa
        if (deleteSecureRoutes.data.status) {
          showAlert(
            this.$t('common.modals.exitoTitulo'),
            this.$t('secureMode.modal.deleteSuccesfull', { name: this.selectedSecureRoute.name }),
            'Succesfull',
          );
          this.$refs.map.setMapNull();
          const indice = this.dataSecureRoutes.findIndex(
            (secureRoute) => secureRoute.id === this.selectedSecureRoute.id,
          );
          if (indice >= 0) {
            this.dataSecureRoutes.splice(indice, 1);
          }
          this.selectedSecureRoute = null;
          this.selectedIdSecureRoute = null;
          this.$refs.map.setMapNull();
          this.tripSecures(this.dataSecureRoutes);
        } else {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            this.$t('secureMode.modal.failDelete', { name: this.selectedSecureRoute.name }),
            'Error',
          );
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    /**
     * Metodo cambia a la vista de creacion e indica que llega ahi para crear
     */
    addTrip() {
      this.showTrips = false;
      this.showMap = true;
      this.actualMode = 'add';
    },
    filterRoutes() {
      let tempRoutes = this.dataSecureRoutes;
      this.isFilterApplied = false;
      if (this.filters.tripName != null) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.name !== undefined) {
            return this.filters.tripName.name === route.name;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      if (this.filters.origin != null) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.idSpotOrigin !== undefined) {
            return this.filters.origin.id === route.idSpotOrigin;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      if (this.filters.destination != null) {
        tempRoutes = tempRoutes.filter((route) => {
          if (route.idSpotDestination !== undefined) {
            return this.filters.destination.id === route.idSpotDestination;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }

      this.tripSecures(tempRoutes);
    },
    cleanFilter() {
      this.isFilterApplied = false;
      this.filters.origin = null;
      this.filters.destination = null;
      this.filters.tripName = null;

      this.restoreSecureTripsList();
    },
    /**
     * Vista informativa, si seleccionas una ruta segura esta te muestra su ruta en el mapa que tiene a su derecha
     * @param {SecureRoute} secureRoute
     */
    async selectSecureRoute(secureRoute) {
      this.selectedSecureRoute = secureRoute;
      //Extraigo el spot del origen y destino por id
      let origin = this.spotsOrigin.find((spot) => spot.id == secureRoute.idSpotOrigin);
      let destination = this.spotsOrigin.find((spot) => spot.id == secureRoute.idSpotDestination);
      //Se construye el body del trip en base al origen y detino
      let trip = [this.buildBody(origin, destination)];
      let rebuildPoints = [];
      if (this.selectedSecureRoute.waypoint) {
        //Se construye el objeto de waypoint para el mapa
        this.selectedSecureRoute.waypoint.forEach((point) => {
          rebuildPoints.push({
            location: {
              lat: point.lat,
              lng: point.lon,
            },
            stopover: false,
          });
        });
      }
      let edit = false;
      let scaleWidth = this.selectedSecureRoute.pathWidth <= 100 ? this.selectedSecureRoute.pathWidth / 10 : 15;
      this.$refs.map.setMapWithPoints(this.gapi, trip, rebuildPoints, edit, scaleWidth);
    },
    /**
     * Metodo que carga todos los datos de la ruta seleccionada en la vista de edicion y creacion de rutas seguras
     */
    async editMode() {
      if (this.selectedSecureRoute) {
        this.showTrips = false;
        this.showMap = true;
        this.actualMode = 'edit';
        //Se obtiene el componente de origen y destino completos a partir de los id entregados por la ruta seleccionada
        let origin = this.spotsOrigin.find((spot) => spot.id == this.selectedSecureRoute.idSpotOrigin);
        let destination = this.spotsOrigin.find((spot) => spot.id == this.selectedSecureRoute.idSpotDestination);
        //Setea los valores de los selectores por los datos de la ruta segura seleccionada
        this.tripName = this.selectedSecureRoute.name;
        this.selectedOrigin = origin;
        this.selectedDestination = destination;
        this.selectedWidth = this.selectedSecureRoute.pathWidth;
        //Se construye el body para mandar al componente del mapa
        let trip = [this.buildBody(origin, destination)];
        let rebuildPoints = [];
        if (this.selectedSecureRoute.waypoint) {
          this.selectedSecureRoute.waypoint.forEach((point) => {
            rebuildPoints.push({
              location: {
                lat: point.lat,
                lng: point.lon,
              },
              stopover: false,
            });
          });
        }
        let edit = true;
        await GoogleMapsApiLoader({
          libraries: ['places', 'marker'],
          apiKey: this.$store.getters.apiKey,
        }).then((google) => {
          this.gapi = google;
        });
        let scaleWidth = this.selectedWidth / 10;
        this.$refs.map.setMapWithPoints(this.gapi, trip, rebuildPoints, edit, scaleWidth);
      } else {
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('secureMode.modal.notSelectedRoute'), 'Error');
      }
    },
    /**
     * Metodo que se encarga de construir el body para el uso del componente del mapa
     */
    buildBody(origin, destination) {
      return {
        origin: origin.name,
        originAddress: origin.address,
        destination: destination.name,
        destinationAddress: destination.address,
        coordinates: {
          origin: {
            lat: origin.address.lat,
            lng: origin.address.lon,
          },
          destination: {
            lat: destination.address.lat,
            lng: destination.address.lon,
          },
        },
      };
    },
    /**
     * Metodo para confirmar la eliminacion de la ruta segura si es que se tiene una seleccionada
     */
    confirmDelete() {
      if (this.selectedSecureRoute) {
        this.isTripsSecureBussy = true;
        showConfirmation(
          this.$t('common.modals.confirmacionTitulo'),
          this.$t('secureMode.modal.confirmDelete', {
            name: this.selectedSecureRoute.name,
            origin: this.selectedSecureRoute.nameSpotOrigin,
            destination: this.selectedSecureRoute.nameSpotDestination,
          }),
          () => {
            this.deleteSecureRoute();
          },
          this.$t('common.cruds.aceptar'),
        );
        this.isTripsSecureBussy = false;
      } else {
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('secureMode.modal.notSelectedRoute'), 'Error');
      }
    },
    //Route en esta vista se considera mas como un viaje que una ruta
    tripSecures(routes) {
      this.secureRoutes = routes;
    },
    restoreSecureTripsList() {
      this.secureRoutes = this.dataSecureRoutes;
    },

    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    /**
     * Metodo para dibujar en el mapa a partir del origen y destino indicados
     */
    async googleRoute() {
      let isValid = this.validateRouteOfTrip(
        this.selectedDestination,
        this.selectedOrigin,
        this.selectedWidth,
        this.tripName,
      );
      if (isValid) {
        let trip = [this.buildBody(this.selectedOrigin, this.selectedDestination)];
        this.showTrip = false;
        this.showMap = true;
        let waypoints = [];
        let edit = true;
        let scaleWidth = this.selectedWidth <= 100 ? this.selectedWidth / 10 : 15;
        await this.$refs.map.setMapWithPoints(this.gapi, trip, waypoints, edit, scaleWidth);
      } else {
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('secureMode.modal.parametersEmpty'), 'Error');
      }
    },
    /**
     * Metodo que verifica que estos campos no esten nulos
     * @param {Spot} destination
     * @param {Spot} origin
     * @param {String} tripName
     * @param {Number} width
     * @returns boolean
     */
    validateRouteOfTrip(destination, origin, tripName, width) {
      return destination != null && origin != null && width != null && tripName != null;
    },
    /**
     * Metodo que permite cambiar de la vista de crear/editar a la informativa
     */
    goBack() {
      this.setDefaultValuesSelectors();
      this.showTrips = true;
      this.showMap = false;
    },
    /**
     * Metodo que se ejcuta al hacer click en el boton guardar, revisa si es un añadir o un editar para saber si usar post o patch
     * primero verifica que los campos esten llenos para poder ejecutar el guardado
     */
    async save() {
      let isValid = this.validateRouteOfTrip(
        this.selectedDestination,
        this.selectedOrigin,
        this.selectedWidth,
        this.tripName,
      );

      if (isValid) {
        this.isTripsSecureBussy = true;
        try {
          let pointsRender = await this.$refs.map.getDirections();
          let waypoints = await this.$refs.map.getWaypoints();
          //Valida que lleguen datos por parte del componente
          if (pointsRender.length > 0 && waypoints) {
            let transformWaypoints = [];
            waypoints.forEach((point) => {
              transformWaypoints.push({
                lat: point.location.lat,
                lon: point.location.lng,
              });
            });
            //Construccion del body
            let body = {
              name: this.tripName,
              description: '',
              idSpotOrigin: this.selectedOrigin.id,
              idSpotDestination: this.selectedDestination.id,
              nameSpotOrigin: this.selectedOrigin.name,
              nameSpotDestination: this.selectedDestination.name,
              pathWidth: this.selectedWidth,
              secureLine: pointsRender,
              waypoint: transformWaypoints,
            };
            try {
              //Verifica si entro en modo añadir realizo un post
              if (this.actualMode == 'add') {
                const response = await this.postSecureRoutes(body);
                if (response.status) {
                  this.dataSecureRoutes.push(response.data);
                  this.tripSecures(this.dataSecureRoutes);
                  showConfirmation(
                    this.$t('common.modals.exitoTitulo'),
                    this.$t('secureMode.modal.createReady'),
                    () => {
                      this.goBack();
                    },
                    this.$t('common.cruds.aceptar'),
                  );
                } else {
                  throw Error;
                }
              }
              //Si entro en modo editar realiza un patch
              else if (this.actualMode == 'edit') {
                const response = await this.patchSecureRoutes(body);
                if (response.status) {
                  //Si salio bien la ejecucion se refresca la vista informativa de rutas seguras
                  const indice = this.dataSecureRoutes.findIndex((secureRoute) => secureRoute.id === response.data.id);
                  if (indice >= 0) {
                    this.dataSecureRoutes[indice] = response.data;
                  }
                  this.tripSecures(this.dataSecureRoutes);
                  showConfirmation(
                    this.$t('common.modals.exitoTitulo'),
                    this.$t('secureMode.modal.editReady', { name: this.tripName }),
                    () => {
                      this.goBack();
                    },
                    this.$t('common.cruds.aceptar'),
                  );
                } else {
                  throw Error;
                }
              }
              this.setDefaultValuesSelectors();
            } catch (e) {
              if (this.errorLog != null && this.errorLog.message == 'alreadyExist') {
                showAlert(
                  this.$t('common.modals.errorTitulo'),
                  this.$t('secureMode.modal.alreadyExist', {
                    origin: this.selectedOrigin.name,
                    destination: this.selectedDestination.name,
                  }),
                  'Error',
                );
                this.errorLog = null;
              } else {
                showAlert(this.$t('common.modals.errorTitulo'), this.$t('secureMode.modal.error'), 'Error');
              }
            }
          } else {
            showAlert(this.$t('common.modals.errorTitulo'), this.$t('secureMode.modal.pathsNotReady'), 'Error');
          }
        } catch (e) {
          console.error(e);
          showAlert(this.$t('common.modals.errorTitulo'), this.$t('secureMode.modal.pathsNotReady'), 'Error');
        }
        this.isTripsSecureBussy = false;
      } else {
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('secureMode.modal.parametersEmpty'), 'Error');
      }
    },
    /**
     * Metodo que setea la vista de edicion/creacion a valores por defecto null y 60 mts
     */
    setDefaultValuesSelectors() {
      this.selectedSecureRoute = null;
      this.selectedIdSecureRoute = null;
      this.tripName = null;
      this.selectedOrigin = null;
      this.selectedDestination = null;
      this.selectedWidth = 60;
    },
    /**
     * genera un custom label para ñadir el mts al multiselect
     */
    labelWidthRoute(width) {
      return `${width} mts.`;
    },
  },
  computed: {
    isNewMapEnabled() {
      const feature = this.$feature('newComponent');
      console.log("El nuevo fgeature esta activo ",feature);
            return feature && this.$store.getters.clientId == 161;
    },
    rows() {
      return this.secureRoutes ? this.secureRoutes.length : 0;
    },
    fieldsTrips() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('secureMode.table.header.tripName'),
          ...common,
        },
        {
          key: 'nameSpotOrigin',
          label: this.$t('secureMode.table.header.origin'),
          ...common,
        },
        {
          key: 'nameSpotDestination',
          label: this.$t('secureMode.table.header.destination'),
          ...common,
        },
      ];
    },
  },
};
